import React from "react";
import UIButton from "../ui-button/component";

export default function OfferBox({
  text,
  price,
  actionLabel,
  onAction,
  className = "",
}) {
  return (
    <div
      className={`bg-brand-orange-light border border-[#F7CFC5] rounded-[18px] p-[22px_24px] flex gap-5 items-center flex-wrap max-sm:flex-col max-sm:items-stretch ${className}`}
    >
      <div className="flex-1 min-w-[200px] text-[15px] leading-[1.55] text-text-dark">
        {text} <strong>{price}</strong>
      </div>
      {actionLabel && (
        <UIButton variant="primary" onClick={onAction} className="w-full sm:w-auto sm:self-center">
          {actionLabel}
        </UIButton>
      )}
    </div>
  );
}
